import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from "react-bootstrap/Modal";
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import {
  ModalContent,
  Card,
  TextQuantity,
  ButtonOutline
} from './styles';
import { InfoButton } from '~/components/layout/Buttons';
import { Creators } from "~/store/ducks/logistic";

const ModalWarningAttachments = ({ modalWarning, setModalWarning }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalWarning(modalOpen);
  }, [modalOpen]);

  useEffect(() => {
    setModalOpen(modalWarning);
  }, [modalWarning]);

  function handleModal() {
    setModalWarning(!modalWarning);
  }

  function handlePath() {
    history.push('/portal');
  }

  return (
    <Modal
      show={modalOpen}
      onHide={() => {
        handleModal()
      }}
      centered={true}
    >
      <Modal.Body>
        <ModalContent>
          <>
            <Card>
              <Row>
                <Col>
                  <TextQuantity style={{ color: '#000FFF', marginBottom: '0.5rem' }}>Ao sair você perderá todos os arquivos já anexados, sendo necessário anexá-los novamente.</TextQuantity>
                </Col>
              </Row>
            </Card>
            <Row>
              <Col>
                <TextQuantity style={{ marginBottom: '1rem', marginTop: '0.5rem' }} >Deseja sair mesmo assim? </TextQuantity>
              </Col>
            </Row>
            <Row>
              <Col>
                <InfoButton onClick={() => handleModal()} style={{ marginTop: '0.5rem' }} >
                  <div>Cancelar</div>
                </InfoButton>
              </Col>
              <Col>
                < ButtonOutline outline onClick={() => handlePath()} style={{ marginTop: '0.5rem' }}>
                  <div>Continuar</div>
                </ButtonOutline>
              </Col>
            </Row>
          </>
        </ModalContent>
      </Modal.Body>
    </Modal>
  );
};

export default ModalWarningAttachments;
